import { Menu } from "lucide-react";
import Button from "../button";
import NavigationSection from "./navigationSection";
import { forwardRef } from "react";

export interface NavigationPrimaryProps {
  children?: React.ReactNode;
  sideBarControl?: boolean;
  sideBarOpened?: boolean;
  setSideBarOpen?: (open: boolean) => void;
}

const NavigationPrimary = forwardRef<HTMLDivElement, NavigationPrimaryProps>(
  (props, ref) => {
    const { children, sideBarControl, sideBarOpened, setSideBarOpen } = props;
    return (
      <NavigationSection ref={ref} className="px-3 py-1.5 gap-4 min-h-10">
        {sideBarControl && (
          <Button
            onClick={() => setSideBarOpen?.(!sideBarOpened)}
            variant="light"
            className="!bg-transparent hover:!bg-slate-100 !shadow-none text-slate-500"
            size="sm"
          >
            <Menu />
          </Button>
        )}
        {children}
      </NavigationSection>
    );
  }
);

export default NavigationPrimary;
